import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { FiLoader, FiDownload } from "react-icons/fi";
import { FaLinkSlash } from "react-icons/fa6";
import { MdOutlineReceipt } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";
import full from './full_logo.png';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;
export const config = {
  Accept: 'application/json',
  headers: {
    // Authorization: `Bearer ${token}`,
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
};
const Helcim = () => {
  const { id } = useParams();
  const [amount, setAmount] = useState();
  const [product, setProduct] = useState('');
  const [loading, setLoading] = useState(true);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [companyLogo, setCompanyLogo] = useState('');
  const [loginId, setLoginId] = useState('');
  const [clientKey, setClientKey] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [successUrl, setSuccessUrl] = useState('');
  const [token, setToken] = useState('');
  const [Surcharge, setSurcharge] = useState(false);
  const [products, setProducts] = useState([]);
  const [userName, setUserName] = useState('');
  const [productEnabled, setProductEnabled] = useState(false);
  const [taxEnabled, setTaxEnabled] = useState(false);
  const [discountEnabled, setDiscountEnabled] = useState(false);
  const [TotalAmount, setTotalAmount] = useState(0);
  const [AddProductPrice, setAddProductPrice] = useState(0);
  const [AddProductDiscount, setAddProductDiscount] = useState(0);
  const [AddProductTax, setAddProductTax] = useState(0);
  const [address, setAddress] = useState([]);
  const [isPaid, setIsPaid] = useState(false);
  const [typeOfPayment, setTypeOfPayment] = useState('');
  const [isExpired, setisExpired] = useState(false);
  const [helcimWholeData, setHelcimWholeData] = useState([]);
  const [baseAmount, setBaseAmount] = useState(0);

  useEffect(() => {
    handleGetPaymentHelcim();
    handleGetPaymentHelcimTocken();
  }, []);

  const handleGetPaymentHelcim = async () => {
    const response = await axios.get(`${baseURL}/payment/helcim/get-link/${id}`, config);
    if (response.data.status === 'success') {
      const entity = response.data.data?.entity;
      const body = entity?.body || {};
      setHelcimWholeData(entity);
      // entity.amount already includes surcharge when surcharge is true
      setAmount(entity.amount);
      // body.amount is the base amount before surcharge
      setBaseAmount(Number(body?.amount ?? entity.actual_amount ?? entity.amount) || 0);
      setProduct(entity.product);
      setCompanyLogo(entity?.company_logo);
      setCompanyName(entity.company_name);
      setLoginId(entity.name);
      setClientKey(entity.token);
      setCompanyId(entity.company_id);
      setSuccessUrl(entity?.success_url);
      setSurcharge(Boolean(entity?.surcharge ?? body?.surcharge));
      setProducts(Array.isArray(body?.products) ? body.products : []);
      setUserName(entity?.name);
      setDiscountEnabled(entity?.settings?.is_discount_enabled);
      setTaxEnabled(entity?.settings?.is_tax_enabled);
      setProductEnabled(entity?.settings?.bill_to_name);
      setAddress(entity?.company_address);
      setIsPaid(entity?.payment_status === 'paid');
      setTypeOfPayment(entity?.type || body?.type || '');
      setisExpired(Boolean(entity?.is_expire));
    }
  };
  useEffect(() => {
    let totalPrice = 0;
    let totalDiscount = 0;
    let Totaltax = 0;
    if (productEnabled === true && products != undefined && products.length > 0) {
      for (const product1 of products) {
        const productTotalPrice = product1.price * product1.quantity;
        totalPrice += productTotalPrice;
        const discountValue = Number(product1.discount) || 0;
        const isUsdDiscount = String(product1.discountType || '').toUpperCase() === 'USD';
        const productTotalDiscount = isUsdDiscount
          ? discountValue
          : (productTotalPrice * discountValue) / 100;
        totalDiscount += productTotalDiscount;
        const productTotalTAX = ((productTotalPrice - productTotalDiscount) * product1.tax) / 100;
        Totaltax += productTotalTAX;
      }
      setAddProductPrice(totalPrice.toFixed(2));
      setAddProductDiscount(totalDiscount.toFixed(2));
      setAddProductTax(Totaltax.toFixed(2));
      setTotalAmount((totalPrice - totalDiscount + Totaltax).toFixed(2));
    }
  }, [loading, amount, products, productEnabled]);

  // Base (before surcharge): products total or body.amount
  const amountAfterDiscount = productEnabled && products?.length
    ? Number(TotalAmount) || Number(baseAmount) || 0
    : Number(baseAmount) || 0;
  const applyConvenienceFee = Surcharge && (typeOfPayment === 'cc' || typeOfPayment === 'card');
  const apiTotal = Number(amount) || 0;
  const convenienceFee = applyConvenienceFee
    ? (apiTotal > amountAfterDiscount
      ? apiTotal - amountAfterDiscount
      : amountAfterDiscount * 0.03)
    : 0;
  const payableTotal = applyConvenienceFee
    ? (apiTotal > amountAfterDiscount ? apiTotal : amountAfterDiscount + convenienceFee).toFixed(2)
    : amountAfterDiscount.toFixed(2);

  const handleInvoice = async () => {
    const invoiceData = helcimWholeData;
    const transactionData = invoiceData.body;
    
    // Create invoice HTML with modern design
    const invoiceHTML = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Invoice - ${transactionData?.invoiceNumber}</title>
        <script src="https://cdn.tailwindcss.com"></script>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
          body { font-family: 'Inter', sans-serif; }
          .invoice-header { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
          .status-paid { background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%); }
          @media print {
            body { print-color-adjust: exact; }
            .no-print { display: none !important; }
          }
        </style>
      </head>
      <body class="bg-gray-50 p-8">
        <div class="max-w-4xl mx-auto bg-white shadow-2xl rounded-xl overflow-hidden">
          <!-- Header -->
          <div class="invoice-header text-white px-8 py-6">
            <div class="flex justify-between items-start">
              <div class="flex items-center space-x-4">
                ${companyLogo ? `<img src="${companyLogo}" alt="Company Logo" class="h-16 w-16 rounded-lg bg-white p-2">` : ''}
                <div>
                  <h1 class="text-2xl font-bold">${companyName}</h1>
                  <p class="text-blue-100">${address?.street_address || ''} ${address?.apartment_or_suite || ''}</p>
                  <p class="text-blue-100">${address?.city || ''}, ${address?.state_or_province || ''} ${address?.zip || ''}</p>
                </div>
              </div>
              <div class="text-right">
                <h2 class="text-3xl font-bold mb-2">INVOICE</h2>
                <div class="status-paid text-white px-4 py-2 rounded-lg inline-block">
                  <span class="font-semibold">PAID</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Invoice Details -->
          <div class="px-8 py-6">
            <div class="grid grid-cols-2 gap-8 mb-8">
              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-3">Bill To:</h3>
                <div class="bg-gray-50 p-4 rounded-lg">
                  <p class="font-medium text-gray-800">${transactionData?.cardHolderName || userName}</p>
                  <p class="text-gray-600">${invoiceData?.email || 'Email not provided'}</p>
                  <p class="text-gray-600">${invoiceData?.phone || ''}</p>
                </div>
              </div>
              <div>
                <h3 class="text-lg font-semibold text-gray-800 mb-3">Invoice Details:</h3>
                <div class="bg-gray-50 p-4 rounded-lg space-y-2">
                  <div class="flex justify-between">
                    <span class="text-gray-600">Invoice #:</span>
                    <span class="font-medium">${transactionData?.invoiceNumber}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-gray-600">Transaction ID:</span>
                    <span class="font-medium">${transactionData?.transactionId}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-gray-600">Date:</span>
                    <span class="font-medium">${new Date(transactionData?.dateCreated).toLocaleDateString()}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="text-gray-600">Approval Code:</span>
                    <span class="font-medium">${transactionData?.approvalCode}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Items -->
            <div class="mb-8">
              <h3 class="text-lg font-semibold text-gray-800 mb-4">Items:</h3>
              <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">
                <table class="w-full">
                  <thead class="bg-gray-50">
                    <tr>
                      <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                      <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">${product}</td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$${amountAfterDiscount.toFixed(2)}</td>
                    </tr>
                    ${applyConvenienceFee && convenienceFee > 0 ? `
                    <tr>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Convenience Fee (3%)</td>
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right">$${convenienceFee.toFixed(2)}</td>
                    </tr>
                    ` : ''}
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Total -->
            <div class="flex justify-end">
              <div class="w-80">
                <div class="bg-gray-50 p-6 rounded-lg">
                  <div class="flex justify-between items-center py-2 border-b border-gray-200">
                    <span class="text-lg font-semibold text-gray-800">Total Amount:</span>
                    <span class="text-2xl font-bold text-gray-800">$${payableTotal}</span>
                  </div>
                  <div class="flex justify-between items-center py-2 mt-2">
                    <span class="text-lg font-semibold text-green-600">Amount Paid:</span>
                    <span class="text-2xl font-bold text-green-600">$${payableTotal}</span>
                  </div>
                  <div class="flex justify-between items-center py-2 mt-2 pt-4 border-t border-gray-200">
                    <span class="text-lg font-semibold text-gray-800">Balance Due:</span>
                    <span class="text-2xl font-bold text-gray-800">$0.00</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Payment Information -->
            <div class="mt-8 bg-blue-50 p-6 rounded-lg">
              <h3 class="text-lg font-semibold text-gray-800 mb-3">Payment Information:</h3>
              <div class="grid grid-cols-2 gap-4">
                <div>
                  <span class="text-gray-600">Payment Method:</span>
                  <span class="ml-2 font-medium">**** ${transactionData?.cardNumber}</span>
                </div>
                <div>
                  <span class="text-gray-600">Status:</span>
                  <span class="ml-2 font-medium text-green-600">${transactionData?.status}</span>
                </div>
              </div>
            </div>

            <!-- Footer -->
            <div class="mt-8 pt-6 border-t border-gray-200 text-center text-gray-500">
              <p>Thank you for your business!</p>
              <div class="flex justify-center items-center mt-4">
                <span class="text-sm">Powered by</span>
                <img src="https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png" class="h-4 ml-2" alt="SalesCaptain">
                <span class="ml-1 font-semibold text-sm">SalesCaptain</span>
              </div>
            </div>
          </div>
        </div>
      </body>
      </html>
    `;

    // Create hidden iframe for printing
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.left = '-9999px';
    iframe.style.top = '-9999px';
    iframe.style.width = '1px';
    iframe.style.height = '1px';
    
    // Append iframe to body
    document.body.appendChild(iframe);
    
    // Write content to iframe
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(invoiceHTML);
    iframeDoc.close();
    
    // Wait for content to load then print
    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow.print();
        // Clean up - remove iframe after printing
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      }, 500);
    };
  };
  const handleGetPaymentHelcimTocken = async () => {
    const response = await axios.get(`${baseURL}/payment/helcim/get-checkout-token/${id}`, config);
    if (response.data.status === 'success') {
      setToken(response?.data?.data?.entity?.checkoutToken);
      setLoading(false);
    }
  };
  const handleupdatehelcimpayment = async (body) => {
    const res = await axios.put(`${baseURL}/payment/helcim/update-helcim-payment/${id}`, body, config);
    // console.log(res);
    if (res.data.status === 'success') {
      // window.open(successUrl, '_self');
      setLoading(true);
      handleGetPaymentHelcim();
      handleGetPaymentHelcimTocken();
    } else {
      // window.alert(res.message);
    }
  };
  // window.addEventListener('message', async (event) => {
  //   const helcimPayJsIdentifierKey = 'helcim-pay-js-' + token;

  //   if (event.data.eventName === helcimPayJsIdentifierKey && event.data.eventStatus === 'SUCCESS') {
  //     const jsonData = JSON.parse(event.data.eventMessage);
  //     const formdata = {
  //       data: jsonData.data.data,
  //       event_status: event.data.eventStatus,
  //     };

  //     await handleupdatehelcimpayment(formdata);
  //   }
  // });
  
  // useEffect(() => {
  //   const handleMessage = async (event) => {
  //     const helcimPayJsIdentifierKey = 'helcim-pay-js-' + token;
    
  //     if (event.data.eventName === helcimPayJsIdentifierKey && event.data.eventStatus === 'SUCCESS') {
  //       const jsonData = JSON.parse(event.data.eventMessage);
  //       const formdata = {
  //         data: jsonData.data.data,
  //         event_status: event.data.eventStatus,
  //       };
    
  //       await handleupdatehelcimpayment(formdata);
    
  //       window.removeEventListener('message', handleMessage);
  //     }
  //   };
    
  //   window.addEventListener('message', handleMessage);
  // },[]);
  useEffect(() => {
    let eventListenerAdded = false;

    const handleMessage = async (event) => {
      const helcimPayJsIdentifierKey = 'helcim-pay-js-' + token;
      if (event.data.eventName === helcimPayJsIdentifierKey && event.data.eventStatus === 'SUCCESS') {
        const jsonData = JSON.parse(event.data.eventMessage);
        const formdata = {
          data: jsonData.data.data,
          event_status: event.data.eventStatus,
        };

        await handleupdatehelcimpayment(formdata);
      }
    };
    if (!eventListenerAdded) {
      window.addEventListener('message', handleMessage);
      eventListenerAdded = true;
    }

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [token]);
  

  if (loading) {
    return (
      <div className="w-full h-[100vh] items-center justify-between flex flex-col">
        <FiLoader size={50} className="animate-spin mt-[47vh]" />
        <div className='bg-[#fff] flex justify-center items-center relative text-[20px] pb-2 h-[1.5rem] w-full rounded-b-[8px] mb-[5vh]'>
          {/* <a href="https://salescaptain.com/" target="_blank" className='underline text-blue-600 font-semibold' rel="noreferrer">
          Visit our website
        </a> */}

          <span className="text-[#535355]"> Powered by</span>
          <div
            className='flex items-center ml-1 cursor-pointer'
            onClick={() => window.open('https://www.salescaptain.com')}
          >
            <img src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} className=" h-[18px]" alt="" />
            <span
              className="font-semibold ml-1"
            >
              {localStorage.getItem('h_name') ?? 'SalesCaptain'}
            </span>
          </div>
        </div>

      </div>
    );
  }

  if (isExpired === true) {
    return (
      <div className="w-full h-full items-center justify-center flex flex-col">
        <FaLinkSlash className="text-[80px] mb-[20px]" />
        <span className="text-[30px] medium">
          Link Expired
        </span>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex flex-col items-center justify-center p-4" id="payment-receipt">
      {/* Modern Header */}
      <div className="w-full max-w-md mb-6">
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/20">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {companyLogo && (
                <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 p-0.5">
                  <div className="w-full h-full rounded-xl bg-white p-2">
                    <img className="w-full h-full object-contain" src={companyLogo} alt="Company Logo" />
                  </div>
                </div>
              )}
              <div className="flex-1">
                <h1 className="text-xl font-bold text-gray-800 leading-tight">{companyName}</h1>
                <p className="text-sm text-gray-500 leading-tight">
                  {address?.street_address} {address?.apartment_or_suite}
                </p>
                <p className="text-sm text-gray-500">
                  {address?.city}, {address?.state_or_province} {address?.zip}
                </p>
              </div>
            </div>
            
            {/* Download Invoice Button - Only show when paid */}
            {isPaid && (
              <div className="ml-4">
                <button 
                  onClick={handleInvoice} 
                  className="group flex items-center space-x-2 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white px-4 py-2 rounded-xl shadow-lg transition-all duration-200 transform hover:scale-105"
                >
                  <FiDownload className="w-4 h-4 group-hover:animate-bounce" />
                  <span className="text-sm font-medium">Invoice</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modern Payment Card */}
      <div className="w-full max-w-md">
        <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/20 overflow-hidden">
          {/* Card Header */}
          <div className="bg-slate-50 p-6">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-lg font-semibold text-slate-800">Payment Details</h2>
                {isPaid && (
                  <p className="text-slate-500 text-sm">Transaction #{helcimWholeData?.transaction_id}</p>
                )}
              </div>
              {isPaid && (
                <div className="flex items-center space-x-2 bg-emerald-50 rounded-full px-3 py-1">
                  <FaCheckCircle className="w-4 h-4 text-emerald-500" />
                  <span className="text-sm font-medium text-emerald-500">Paid</span>
                </div>
              )}
            </div>
          </div>

          {/* Card Content */}
          <div className="p-6 ">
            {/* Bill To */}
            <div className="flex items-center justify-between py-3 border-b border-gray-100">
              <span className="text-gray-600 font-medium">Bill to:</span>
              <span className="text-gray-800 font-semibold">{userName}</span>
            </div>

            {/* Product Details */}
            {productEnabled === true && products?.length > 1 && (
              <div className="border-b border-gray-100 pb-4">
                <h3 className="text-gray-600 font-medium mb-3">Products:</h3>
                <div className="space-y-2 max-h-32 overflow-y-auto">
                  {products?.map((field, index) => (
                    <div key={index} className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">
                        {field.quantity}× {field.product}
                      </span>
                      <span className="font-medium text-gray-800">
                        ${(field.price * field.quantity).toFixed(2)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Single Product or Service */}
            {(productEnabled === true && products?.length === 1) || !productEnabled && (
              <div className="text-center py-4 border-b border-gray-100">
                <div className="inline-flex items-center space-x-2 bg-gray-50 rounded-full px-4 py-2">
                  <MdOutlineReceipt className="w-4 h-4 text-gray-500" />
                  <span className="text-gray-700 font-medium">
                    {productEnabled ? products[0]?.product : product}
                  </span>
                </div>
              </div>
            )}

            {/* Amount Breakdown */}
            <div className="space-y-3">
              {/* Subtotal */}
              <div className="flex items-center justify-between">
                <span className="text-gray-600">Subtotal</span>
                <span className="font-medium text-gray-800">
                  ${productEnabled && products?.length ? AddProductPrice : amountAfterDiscount.toFixed(2)}
                </span>
              </div>

              {/* Discount */}
              {discountEnabled && productEnabled && products?.length > 0 && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Discount</span>
                  <span className="font-medium text-red-500">-${AddProductDiscount}</span>
                </div>
              )}

              {/* Tax */}
              {taxEnabled && productEnabled && products?.length > 0 && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Tax</span>
                  <span className="font-medium text-gray-800">${AddProductTax}</span>
                </div>
              )}

              {/* Convenience Fee */}
              {applyConvenienceFee && convenienceFee > 0 && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600 text-sm">Convenience fee (3%)</span>
                  <span className="font-medium text-gray-800">
                    ${convenienceFee.toFixed(2)}
                  </span>
                </div>
              )}

              {/* Total Amount */}
              <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                <span className="text-lg font-semibold text-gray-800">
                  {isPaid ? 'Total Paid' : 'Total Amount Payable'}
                </span>
                <span className="text-xl font-bold text-gray-800">
                  ${payableTotal}
                </span>
              </div>

              {/* Balance Due */}
              {isPaid && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Balance Due</span>
                  <span className="font-bold text-green-600">$0.00</span>
                </div>
              )}
            </div>

            {/* Action Button */}
            <div className="pt-4">
              {isPaid ? (
                <div className="w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white font-semibold py-4 text-center rounded-2xl">
                  <div className="flex items-center justify-center space-x-2">
                    <FaCheckCircle className="w-5 h-5" />
                    <span>Payment Completed</span>
                  </div>
                </div>
              ) : (
                <a
                  href={`javascript: appendHelcimPayIframe('${token}', true)`}
                  className="block w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold py-4 text-center rounded-2xl transition-all duration-200 transform hover:scale-105 shadow-lg"
                  onClick={() => setPaymentLoading(true)}
                >
                  {paymentLoading ? (
                    <div className="flex items-center justify-center space-x-2">
                      <FiLoader className="w-5 h-5 animate-spin" />
                      <span>Processing...</span>
                    </div>
                  ) : (
                    'Pay Now'
                  )}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 flex items-center space-x-2 text-gray-500">
        <span className="text-sm">Powered by</span>
        <img className="h-4" src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} alt="SalesCaptain" />
        <span className="text-sm capitalize">{localStorage.getItem('h_name') ?? 'SalesCaptain'}</span>
      </div>

      <script async defer type="text/javascript" src="https://secure.helcim.app/helcim-pay/services/start.js"></script>
    </div>
  );
};

export default Helcim;
